import { type SyntheticEvent, useRef } from 'react';

import { passwordCopy } from '@nesso/ui/lib/password.schema';
import { AuthPasswordField } from '@nesso/ui/primitives/auth-password-field';
import { Button } from '@nesso/ui/primitives/button';
import { FieldError } from '@nesso/ui/primitives/field';

type Props = {
    password: string;
    error?: string;
    formError?: string;
    isSubmitting: boolean;
    setPassword: (value: string) => void;
    onPasswordBlur: () => void;
    onSubmit: (event: SyntheticEvent<HTMLFormElement>) => Promise<'password' | undefined>;
};

export function ConfirmPasswordResetForm({
    password,
    error,
    formError,
    isSubmitting,
    setPassword,
    onPasswordBlur,
    onSubmit,
}: Props) {
    const passwordRef = useRef<HTMLInputElement>(null);

    const handleSubmit = async (event: SyntheticEvent<HTMLFormElement>) => {
        const fieldToFocus = await onSubmit(event);
        if (fieldToFocus === 'password') passwordRef.current?.focus();
    };

    return (
        <form className="flex flex-col gap-6" noValidate onSubmit={handleSubmit}>
            <AuthPasswordField
                ref={passwordRef}
                id="reset-password"
                label="New password"
                value={password}
                error={error}
                disabled={isSubmitting}
                autoComplete="new-password"
                description={passwordCopy.complexity}
                onChange={setPassword}
                onBlur={onPasswordBlur}
            />

            {formError ? <FieldError>{formError}</FieldError> : null}

            <Button type="submit" size="lg" className="w-full" disabled={isSubmitting}>
                Confirm Password
            </Button>
        </form>
    );
}
